<template>
  <div :class="['players-list', (clsName || '')]">
    <div class="main-header" v-if="heading">
      <h3 class="title">{{ heading }}</h3>
    </div>
    <div class="player-item sub-header">
      <div class="item item-1">{{ translations.name }}</div>
      <div class="item item-2 grade-section">
        <div class="grade-wrap">
          <span class="title-1">{{ translations.fantasyGully }}</span>
          <span class="title-2">{{ translations.rating }}</span>
        </div>
        <span
          :class="['info-wrap', rating_tool_tip.recommended_11 ? 'active' : '']"
          @click.stop="closeToolTipExcept('rating_tool_tip', 'recommended_11')"
        >
          <div
            class="info-modal"
            v-show="rating_tool_tip.recommended_11"
            @click.stop="closeToolTipExcept"
          >
            <p>{{ translations.modal_txt_rating }}</p>
          </div>
        </span>
      </div>
      <div class="item item-3 x-factor">
        <img
          src="/static-assets/images/cssimages/x-factor-web.png"
          class="x-factor-img"
          alt=""
        />
        <span
          :class="['info-wrap', xf_tool_tip.recommended_11 ? 'active' : '']"
          @click.stop="closeToolTipExcept('xf_tool_tip', 'recommended_11')"
        >
          <div
            class="info-modal"
            v-show="xf_tool_tip.recommended_11"
            @click.stop="closeToolTipExcept"
          >
            <p>{{ translations.modal_txt_xf }}</p>
          </div>
        </span>
      </div>
      <div class="item item-4 more-info">
        <span class="icon-lock"></span>
        <span
          :class="['info-wrap', lock_tool_tip.recommended_11 ? 'active' : '']"
          @click.stop="closeToolTipExcept('lock_tool_tip', 'recommended_11')"
        >
          <div
            class="info-modal"
            v-show="lock_tool_tip.recommended_11"
            @click.stop="closeToolTipExcept"
          >
            <p>{{ translations.modal_txt_lock }}</p>
          </div>
        </span>
      </div>
    </div>
    <div class="player-details" v-if="!teamList.length">
        <div class="player-item isempty" v-for="i in 11" v-bind:key="i"></div>
    </div>
    <div class="player-details" v-else>
      <div
        class="player-item"
        v-for="player in teamList"
        v-bind:key="player.pid"
      >
        <div class="item item-1 item1-wrap">
          <div class="skill-wrap">
            <span class="player-skill-txt">{{
              printSkillName(player.sid, "sname")
            }}</span>
            <span class="trending" v-if="player.in_form"></span>
            <span
              v-if="player.in_form"
              :class="[
                'player-skill info-wrap trending',
                { active: trending_tool_tip[player.pid] },
              ]"
              @click.stop="addToTrending(player.pid)"
            >
              <div class="info-modal">
                <p>{{ translations.modal_txt_trending }}</p>
              </div>
            </span>
          </div>
          <div
            class="player-name-wrap no-select"
            @click="onOpenPlayerPopup(player)"
          >
            <span>{{ player.pn }}</span>
            <span
              >{{ player.tsn }} | {{ translations.price }} -
              <span class="price">{{ player.pr }}</span>
            </span>
          </div>
          <span class="main-player captain" v-if="player.is_c"></span>
          <span
            class="main-player vice-captain"
            v-else-if="player.is_vc"
          ></span>
        </div>
        <div class="item item-2">{{ ratingDisplayVal(player.fr) }}</div>
        <div class="item item-3 ratings">
          <rating-meter :meterVal="player.xfp" />
        </div>
        <div class="item item-4 reactions in-out-section">
          <span
            :class="[
              'react',
              'btn-in',
              locked_players.includes(+player.pid) ? 'active' : null,
              current_match.status !== 1 ? 'btn-disabled' : null,
            ]"
            @click="lockPlayer('in', +player.pid)"
            >{{ translations.in }}</span
          >
          <span
            :class="[
              'react',
              'btn-out',
              out_players.includes(+player.pid) ? 'active' : null,
              current_match.status !== 1 ? 'btn-disabled' : null,
            ]"
            @click="lockPlayer('out', +player.pid)"
            >{{ translations.out }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RatingMeter from "../../common/RatingMeter";
export default {
    props: ["current_match", "heading", "clsName", "rating_tool_tip", "xf_tool_tip", "lock_tool_tip", "closeToolTipExcept", "teamList", "printSkillName", "trending_tool_tip", "addToTrending", "onOpenPlayerPopup", "ratingDisplayVal", "locked_players", "out_players", "lockPlayer"],
    components: {
        RatingMeter
    },
    computed: {
        translations() {
            return this.$store.state.translations;
        }
    }
};
</script>